import EditRubricForm from 'components/Rubrics/EditRubricForm';
import { useTranslation } from 'react-i18next';
import { Button, Container, Icon, Stack, styled, Text } from 'shell/components';

const TabletResult = ({
    result,
    setResult,
    rubricErrors,
    setRubricErrors,
    hasClickedSubmitRubric,
    validateTitle,
    validateCriteria,
    onClickEditSettings,
}) => {
    const { t } = useTranslation('assignment');

    return (
        <CustomContainer device={'tablet'}>
            <RootStack alignItems={'flex-start'} spacing={5}>
                <Stack spacing={2}>
                    <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                        {t('rubric.create-ai-rubric.review.title', 'Review Rubric')}
                    </Text>
                    <Text>
                        {t(
                            'rubric.create-ai-rubric.review.description',
                            'Please review and verify all AI-generated information for accuracy and completeness.'
                        )}
                    </Text>
                </Stack>
                <CustomButton startIcon={<Icon kind={'edit'} />} variant={'secondary'} onClick={onClickEditSettings}>
                    {t('rubric.create-ai-rubric.review.edit-button', 'Edit')}
                </CustomButton>
                <CustomEditRubricForm
                    form={result}
                    setForm={setResult}
                    errors={rubricErrors}
                    setErrors={setRubricErrors}
                    hasClickedSubmit={hasClickedSubmitRubric}
                    validateTitle={validateTitle}
                    validateCriteria={validateCriteria}
                />
            </RootStack>
        </CustomContainer>
    );
};

const CustomContainer = styled(Container)(({ theme }) => {
    return {
        background: theme.palette.ensightful.shades[0],
    };
});

const RootStack = styled(Stack)(() => {
    return {
        width: '100%',
    };
});

const CustomButton = styled(Button)(() => {
    return {
        zIndex: 1,
        alignSelf: 'flex-end',
    };
});

const CustomEditRubricForm = styled(EditRubricForm)(() => {
    return {
        position: 'relative',
        top: '-56px',
    };
});

export default TabletResult;
